import { X, Trash2 } from "lucide-react";

export default function ConfirmDeleteDialog({
  open,
  title = "Delete credential?",
  description,
  confirmLabel = "Delete",
  onCancel,
  onConfirm,
  loading,
}) {
  if (!open) return null;
  return (
    <div
      data-testid="confirm-delete-dialog"
      className="fixed inset-0 z-50 flex items-center justify-center bg-[#0B1221]/70 p-6"
      onClick={onCancel}
    >
      <div
        className="relative w-full max-w-sm border border-slate-200 bg-white p-7"
        onClick={(e) => e.stopPropagation()}
      >
        <button
          type="button"
          data-testid="confirm-delete-close"
          onClick={onCancel}
          className="absolute right-3 top-3 flex h-8 w-8 items-center justify-center text-slate-400 hover:text-[#0B1221]"
        >
          <X className="h-4 w-4" />
        </button>

        <div className="font-mono text-[11px] uppercase tracking-[0.22em] text-red-600">
          Destructive action
        </div>
        <h3 className="font-display mt-1 text-2xl font-bold tracking-tight text-[#0B1221]">
          {title}
        </h3>
        {description && (
          <p className="mt-2 text-sm text-slate-600">{description}</p>
        )}

        <div className="mt-6 flex gap-3">
          <button
            type="button"
            data-testid="confirm-delete-cancel"
            onClick={onCancel}
            className="flex-1 border border-slate-300 bg-white px-4 py-3 text-sm font-semibold uppercase tracking-wider text-[#0B1221] transition-colors hover:border-[#0B1221]"
          >
            Cancel
          </button>
          <button
            type="button"
            data-testid="confirm-delete-confirm"
            onClick={onConfirm}
            disabled={loading}
            className="flex-1 inline-flex items-center justify-center gap-2 bg-red-600 px-4 py-3 text-sm font-semibold uppercase tracking-wider text-white transition-colors hover:bg-red-700 disabled:opacity-60"
          >
            <Trash2 className="h-4 w-4" />
            {loading ? "Deleting…" : confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
